import React from "react";
import Editor from "@monaco-editor/react";
import { useSelector } from "react-redux";

const VALIDATE_ICON = "e-icons e-check";
const ERROR_ICON   = "e-icons e-close";
const IDLE_ICON    = "e-icons e-code";

const JSCodeEditor = ({ label, name, value = "", onChange, height = 320 }) => {
  const [syntaxResult, setSyntaxResult] = React.useState(null); // null | { ok, message }
  const editorRef = React.useRef(null);
  const { defConfig, defLang } = useSelector((state) => state.Login);
  const c = defConfig?.[defLang] || {};

  const handleMount = (editor) => {
    editorRef.current = editor;
  };

  const handleChange = (val) => {
    setSyntaxResult(null);
    onChange({ target: { name, value: val ?? "" } });
  };

  const validateSyntax = () => {
    const code = editorRef.current?.getValue() ?? value;
    try {
      /* Wrapping in async fn handles top-level await used in connector scripts */
      new Function(`return (async()=>{ ${code} })`);
      setSyntaxResult({ ok: true, message: c.mcnSyntaxOk || "Syntax OK — no errors found." });
    } catch (err) {
      setSyntaxResult({ ok: false, message: err.message });
    }
  };

  return (
    <div className="xjse-wrapper">
      <div className="xjse-header">
        <span className="xjse-label">{label}</span>
        <button
          type="button"
          className={"xjse-validate-btn e-btn e-small" + (syntaxResult?.ok === false ? " e-danger" : syntaxResult?.ok ? " e-success" : "")}
          onClick={validateSyntax}
          title={c.mcnValidateSyntaxTitle || "Validate JavaScript syntax"}
        >
          <span className={syntaxResult?.ok === false ? ERROR_ICON : syntaxResult?.ok ? VALIDATE_ICON : IDLE_ICON}></span>
          {c.mcnValidateSyntax || "Validate syntax"}
        </button>
      </div>

      <div className="xjse-editor-wrap">
        <Editor
          height={height}
          defaultLanguage="javascript"
          value={value}
          theme="vs-dark"
          onMount={handleMount}
          onChange={handleChange}
          options={{
            fontSize: 13,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            wordWrap: "on",
            tabSize: 2,
            automaticLayout: true,
            lineNumbers: "on",
            renderLineHighlight: "all",
            formatOnPaste: true,
            suggestOnTriggerCharacters: true,
          }}
        />
      </div>

      {syntaxResult && (
        <div className={"xjse-result " + (syntaxResult.ok ? "xjse-ok" : "xjse-error")}>
          <span className={syntaxResult.ok ? VALIDATE_ICON : ERROR_ICON}></span>
          {syntaxResult.message}
        </div>
      )}
    </div>
  );
};

export default JSCodeEditor;
